import React, { CSSProperties, memo, ReactElement, useCallback } from 'react';

import { AcBadge } from '@ac/mobile-components/dist/components/badge';
import { AcBasicBadgeProps } from '@ac/mobile-components/dist/components/badge/AcBadge';
import { AcFlex } from '@ac/mobile-components/dist/components/flex';
import { AcText } from '@ac/mobile-components/dist/components/text';
import { Color, TextSize } from '@ac/mobile-components/dist/enums';
import { Styleable } from '@ac/mobile-components/dist/interfaces/componentProps';
import {
  getBorderColorClass,
  getTestSelectorAttribute,
  isColorEnum
} from '@ac/mobile-components/dist/utils';

import './BadgeWithCount.css';

interface RenderCountProps {
  borderClass?: Color | string;
  borderColor?: Color | string;
}
interface BadgeWithCountBaseProps {
  count?: number;
  renderCount?: (props: RenderCountProps) => ReactElement | null;
  testSelector?: string;
}

export type BadgeWithCountProps = AcBasicBadgeProps &
  BadgeWithCountBaseProps &
  Styleable;

const BadgeWithCount: React.FC<BadgeWithCountProps> = ({
  count,
  renderCount,
  className,
  testSelector,
  ...badgeProps
}) => {
  const classes = {
    container: 'badge-with-count',
    countContainer: 'badge-with-count-container'
  };

  const internalRenderCount = useCallback(() => {
    const borderColor = badgeProps.borderColor || badgeProps.backgroundColor;
    const isColorAnEnum = isColorEnum(borderColor);
    const renderCountProps: RenderCountProps = {
      borderClass: isColorAnEnum
        ? getBorderColorClass(borderColor as Color)
        : undefined,
      borderColor: !isColorAnEnum ? borderColor : undefined
    };

    const styles: CSSProperties = {
      borderColor: renderCountProps.borderColor
    };

    badgeProps.borderColor = borderColor;

    if (count !== undefined && count !== null) {
      return (
        <div
          className={`${classes.countContainer} ${renderCountProps.borderClass}`}
          style={styles}
          {...getTestSelectorAttribute(testSelector)}
        >
          <AcText size={TextSize.Main2} testSelector={`${testSelector}-count`}>
            {count}
          </AcText>
        </div>
      );
    }

    return renderCount && renderCount(renderCountProps);
  }, [count, renderCount, badgeProps.borderColor]);

  return (
    <AcFlex className={`${className} ${classes.container}`}>
      <AcBadge {...badgeProps} />
      {internalRenderCount()}
    </AcFlex>
  );
};

export default memo(BadgeWithCount);



// WEBPACK FOOTER //
// ./src/components/shared/BadgeWithCount/BadgeWithCount.tsx